<div [ngClass]="{'dark-theme': darkMode$ | async}">
    <router-outlet></router-outlet>
    @if (loading$ | async) {
    <div class="loading-wrap" [ngClass]="(darkMode$ | async) ? 'dbg' : 'lbg'">
        <span class="loader"></span>
    </div>
    }
</div>
